export default __webpack_public_path__ + "static/media/spacman.0f0495e7.gif";